import { LayoutRectangle, Platform, View } from 'react-native'
import { useState } from 'react'
import { MagicGlowProps } from './MagicGlow.types'
import MagicGlowCanvas from './MagicGlowCanvas'

const MagicGlow = ({ borderRadius }: MagicGlowProps) => {
  const [dimensions, setDimensions] = useState<LayoutRectangle | null>(null)

  return (
    <View
      onLayout={({ nativeEvent }) => {
        setDimensions(nativeEvent.layout)
      }}
      className="pointer-events-none absolute inset-0 flex h-full w-full flex-1 "
    >
      {dimensions && Platform.OS === 'web' && (
        <MagicGlowCanvas
          width={dimensions.width}
          height={dimensions.height}
          borderRadius={borderRadius}
          opacity={0.7}
          blur={20}
          duration={3000}
          fillWidth={20}
        />
      )}
    </View>
  )
}

export default MagicGlow
